import {
  GetUserData,
  UpdateUserAccount,
} from '@/api/auth';
import { 
  AddPlan,
  GetAllCardsInfo, 
  AddCard, 
  UpdateCard, 
  DeleteCard,
} from '@/api/billing';
import { 
  sendToNotarize,
  confirmSendToNotarize1583,
  CancelNotarize1583,
  CancelItemNotarize,
  getAllNotarizePackages,
  performCustomAction,
  getForwardingAddresses,
  performSmsServiceAction,
  getUserStats,
  getJointAccounts,
  addJointAccount,
  updateJointAccount,
  removeJointAccount,
  getUserPhones,
  GetPhoneNumber,
  getUserPhoneUsages,
  searchPhoneNumbers,
  buyPhoneNumber,
  updatePhoneNumber,
  deletePhoneNumber,
  getOutgoingCallFroms,
  addOutgoingCallNumber,
  updateOutgoingCallNumber,
  deleteOutgoingCallNumber,
  validateNewAccount,
  ValidateClient,
  addForwardingAddress,
  editForwardingAddress,
  removeForwardingAddress,
  getLiveReceptionistList,
  subscribeToLiveReceptionist,
  unsubscribeFromLiveReceptionist,
  getPhonePorting,
  sendPhonePorting,
  getPhoneExtensions,
  createPhoneExtension,
  updatePhoneExtension,
  removePhoneExtension,
  updateAutomaticMailAction,
  GetCharges,
  GetUserPlan,
  GetCurrentStats,
  GetTransferClients,
  GetClientPlans,
  TransferAccount,
  UpgradePlan,
  UploadAccountDocument,
  GetBalanceAdjustments,
  UpdatePhotoIdExpiration,
  GetGeneratedCADocument,
  GenerateCADocument,
  SubmitCAForApproval
} from '@/api/account';
// eslint-disable-next-line import/no-cycle

export const userData = ({ commit, dispatch }) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetUserData()
    .then((res) => {
      commit('UPDATE_USER_DATA', res);
      return res;
    }))
  .catch((e) => {
    console.log('err check auth on userData', e);
  });

export const updateUser = ({ commit, dispatch }, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateUserAccount(params)
    .then((res) => {
      commit('UPDATE_USER_DATA', res);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    })));

export const getUserPlan = ({commit, state, dispatch}, forceRequest) => dispatch('CheckAuth', null, {root: true})
  .then(() => new Promise((resolve, reject) => {
    if (forceRequest || !Object.keys(state.userPlan).length) {
      GetUserPlan()
        .then(res => {
          if (res && res.plan) {
            commit('SAVE_USER_PLAN', res);
            resolve(res.plan);
          } else {
            resolve({});
          }
        });
    } else {
      resolve(state.userPlan);
    }
  }))
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }))

export const validateAccount = ({commit, dispatch}, params) => validateNewAccount(params)
  .then((res) => res);

export const validateClient = ({commit, dispatch}, params) => ValidateClient(params)
  .then((res) => res);

export const customUserAction = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => performCustomAction(params)
    .then(() => GetUserData()
      .then((res) => {
        commit('UPDATE_USER_DATA', res);
        return res;
      })
      .catch(e => new Promise((resolve, reject) => {
        reject(e);
      })))
);

export const subscriptionToPlan = ({ commit, dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => AddPlan(data)
    .then(res => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    })));

export const getAllCards = ({ commit, dispatch }) => {
  commit('CARDS_REQUEST_DISPATCH');

  dispatch('CheckAuth', null, {root: true})
    .then(() => GetAllCardsInfo()
      .then((res) => {
        commit('CARDS_REQUEST_SUCCESS');
        commit('UPDATE_BILLING_DATA', res.credit_cards);
      })
    );
}

export const addCard = ({ dispatch }, data) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => AddCard(data)
    .then((res) => {
      dispatch('getAllCards');
      return res;
    })
  );

export const setAsDefaultCard = ({ dispatch, state }, id) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => UpdateCard(id, {
    source: {
      default: true,
    },
  })
    .then(() => {
      let defaultCardOld = state.billingData.find(item => item.default);

      if (defaultCardOld) {
        defaultCardOld.default = false;

        state.billingData.find(item => item.id === id).default = true;

        const newArr = state.billingData.filter(item => !item.default);
        const defaultCard = state.billingData.find(item => item.default);

        newArr.unshift(defaultCard);

        state.billingData = newArr;
      } else {
        dispatch('getAllCards');
      }
    })
  );

export const updateCardExp = ({ dispatch }, params) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => UpdateCard(params.id, 
    {
      source: params.data,
    })
    .then(() => {
      dispatch('getAllCards');
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const deleteCard = ({ dispatch, state }, id) => dispatch('CheckAuth', null, {root: true})
  // eslint-disable-next-line no-undef
  .then(() => DeleteCard(id)
    .then(() => {
      state.billingData = state.billingData.filter(item => item.id !== id);
      // dispatch('getAllCards');
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  );

export const sendNotarize = ({rootGetters, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => sendToNotarize(data)
    .then((res) => {
      let access = rootGetters['auth/access'];

      if (access.refresh_token) 
        dispatch('auth/refresh', access.refresh_token, {root: true});

      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const confirmSendNotarize1583 = ({rootGetters, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => confirmSendToNotarize1583(data)
    .then((res) => {
      let access = rootGetters['auth/access'];

      if (access.refresh_token) 
        dispatch('auth/refresh', access.refresh_token, {root: true});

      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

  export const cancelNotarize1583 = ({rootGetters, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CancelNotarize1583(data)
    .then((res) => {
      let access = rootGetters['auth/access'];

      if (access.refresh_token) 
        dispatch('auth/refresh', access.refresh_token, {root: true});

      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

  export const cancelItemNotarize = ({rootGetters, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CancelItemNotarize(data)
    .then((res) => {
      let access = rootGetters['auth/access'];

      if (access.refresh_token) 
        dispatch('auth/refresh', access.refresh_token, {root: true});

      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getAllNotarize = ({ commit, dispatch }) => dispatch('CheckAuth', null, {root: true})
  .then(() => getAllNotarizePackages()
    .then(res => {
      commit('SAVE_NOTARIZE_LIST', res);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCADocument = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetGeneratedCADocument()
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const generateCADocument = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GenerateCADocument(data)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const submitCAForApproval = ({commit, dispatch},id) => dispatch('CheckAuth', null, {root: true})
  .then(() => SubmitCAForApproval(id)
    .then((res) => {
      return res; 
    }).catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )
export const getFwdAddrList = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => getForwardingAddresses(params)
    .then((list) => {
      commit('SAVE_FWD_ADDR_LIST', list);
      return list;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const smsServiceAction = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => performSmsServiceAction(params)
    .then((res) => {
      commit('SAVE_SMS_SERVICE_PARAMS', res);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getActivity = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => getUserStats()
    .then((res) => {
      commit('SAVE_USER_STATS', res);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getCurrentActivity = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCurrentStats()
    .then(res => {
      return res.current_stats;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getRecipients = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => getJointAccounts()
    .then((list) => commit('SAVE_JOINT_ACCOUNTS', list))
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addRecipient = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => addJointAccount(data)
    .then((res) => commit('ADD_JOINT_ACCOUNT', res))
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateRecipient = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => updateJointAccount(data)
    .then((res) => commit('UPDATE_JOINT_ACCOUNT', res))
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const removeRecipient = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => removeJointAccount(id)
    .then(() => commit('REMOVE_JOINT_ACCOUNT', id))
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getPhoneList = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => getUserPhones()
    .then((res) => {
      commit('SAVE_PHONE_LIST', res);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getPhoneNumber = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetPhoneNumber(id)
    .then((res) => {
      return res.phone_number;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getPhoneUsage = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => getUserPhoneUsages()
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )
  
export const getAvailablePhones = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => searchPhoneNumbers(params)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const buyNumber = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => buyPhoneNumber(params)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateNumber = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => updatePhoneNumber(data.params, data.id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const deleteNumber = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => deletePhoneNumber(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getOutgoingNumbers = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => getOutgoingCallFroms(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const addOutgoingNumber = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => addOutgoingCallNumber(data)
    .then((res)=> res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateOutgoingNumber = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => updateOutgoingCallNumber(data)
    .then((res)=> res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )
  export const updatePhotoIdExpiresAt = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdatePhotoIdExpiration(data)
    .then((res)=> res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )


export const deleteOutgoingNumber = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => deleteOutgoingCallNumber(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getExtensions = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => getPhoneExtensions(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const createExtension = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => createPhoneExtension(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const updateExtension = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => updatePhoneExtension(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const removeExtension = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => removePhoneExtension(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )


export const updateAutomaticMail = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => updateAutomaticMailAction(params.data , params.id , params.action , params.role)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )


export const addFwAddress = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => addForwardingAddress(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const editFwAddress = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => editForwardingAddress(params.data, params.id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const removeFwAddress = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => removeForwardingAddress(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getReceptionistList = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => getLiveReceptionistList()
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const subToReceptionist = ({commit, dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => subscribeToLiveReceptionist(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const unsubFromReceptionist = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => unsubscribeFromLiveReceptionist()
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getPortRequest = ({commit, dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => getPhonePorting()
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const sendPortRequest = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => sendPhonePorting(data)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getUserCharges = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetCharges(params)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const saveForm1583Status = ({commit, dispatch}, val) => dispatch('CheckAuth', null, {root: true})
.then(() => commit('SAVE_FORM1583_STATUS', val));

export const getTransferClients = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetTransferClients()
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getClientPlans = ({dispatch}, id) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetClientPlans(id)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const transferAccount = ({dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => TransferAccount(params)
    .then((res) => res)
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const upgradePlan = ({commit, dispatch}, params) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpgradePlan(params)
    .then((res) => {
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const uploadDocument = ({commit, dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UploadAccountDocument(data)
    .then(res => {
      commit('SAVE_ACCOUNT_DOCUMENT', res.account_document);
      return res;
    })
    .catch(e => new Promise((resolve, reject) => {
      reject(e);
    }))
  )

export const getBalanceAdjustments = ({commit, dispatch}, params = {}) => dispatch('CheckAuth', null, {root: true})
.then(() => GetBalanceAdjustments(params)
  .then(res => {
    return res;
  })
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }))
)